import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  scrollAnchor: {
    height: 1,
    flexShrink: 0,
  },
  // Centered date divider with a hairline rule on each side ("Today",
  // "Yesterday", "June 24"). Lines are drawn with pseudo-elements so the label
  // stays centered regardless of its width.
  daySeparator: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    '&::before, &::after': {
      content: '""',
      flex: 1,
      height: 1,
      backgroundColor: theme.palette.labraChat.separator,
    },
  },
  daySeparatorLabel: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 11,
    lineHeight: '16px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    color: theme.palette.labraText.description,
    whiteSpace: 'nowrap',
  },
}))
